import { ExpandMore } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { Accordion, Typography, Grid, AccordionDetails } from '@mui/material';
import { FormikProps } from 'formik';
import React, { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { BatchDownloadAnprFileFilters } from 'system/pages/batch-management/file-managment/download-anpr/list/types';
import { DatePicker } from '@mui/lab';

interface BatchDownloadFilesFiltersProps {
  downloadFileForm: FormikProps<BatchDownloadAnprFileFilters>;
}
const BatchDownloadFileFiltersComponent = ({
  downloadFileForm,
}: BatchDownloadFilesFiltersProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-batch-content"
          id="panel-batch-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={downloadFileForm.handleSubmit}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  label="Titolo"
                  aria-label="Titolo"
                  id="titoloid"
                  fullWidth
                  value={downloadFileForm.values.title || ''}
                  onChange={(event) => {
                    downloadFileForm.setFieldValue('title', event.target.value);
                  }}
                  error={downloadFileForm.touched?.title && Boolean(downloadFileForm.errors?.title)}
                  helperText={downloadFileForm.errors?.title}
                ></PmiTextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <DatePicker
                  label="Data inizio"
                  aria-label="Data inizio"
                  value={downloadFileForm.values.startDate || null}
                  onChange={(date) => downloadFileForm.setFieldValue('startDate', date)}
                  disableFuture
                  maxDate={downloadFileForm.values.endDate}
                  renderInput={(params) => (
                    <PmiTextField
                      {...params}
                      id="startDateid"
                      fullWidth
                      error={
                        downloadFileForm.touched?.startDate &&
                        Boolean(downloadFileForm.errors?.startDate)
                      }
                      helperText={downloadFileForm.errors?.startDate}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <DatePicker
                  label="Data fine"
                  aria-label="Data fine"
                  value={downloadFileForm.values.endDate || null}
                  onChange={(date) => downloadFileForm.setFieldValue('endDate', date)}
                  disableFuture
                  minDate={downloadFileForm.values.startDate}
                  renderInput={(params) => (
                    <PmiTextField
                      {...params}
                      id="endDateid"
                      fullWidth
                      error={
                        downloadFileForm.touched?.endDate &&
                        Boolean(downloadFileForm.errors?.endDate)
                      }
                      helperText={downloadFileForm.errors?.endDate}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <PmiButton fullWidth variant="contained" color="secondary" type="submit">
                  Cerca
                </PmiButton>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

BatchDownloadFileFiltersComponent.displayName = 'Batch download file filters component';
const DownloadFileFormComponent = memo(BatchDownloadFileFiltersComponent);
export default DownloadFileFormComponent;
